import React from 'react';
import Results from './index';

const AdminResults: React.FC = () => {
  return <Results isAdmin={true} />;
};

export default AdminResults; 